<main>
  <div class="app app-margin bgImg">
<div class="resetpassbox vertical-center hgt-473" >
  <div class="resetpassWindow" >

    <div class="top">
      <div class="econFont"><i class="icon icon-econ"></i></div>

      <div class="loginheader marT20">{{'Ericsson Connect to Learn' | translate}}</div>
   </div>
      <div class="panel-body">

        <label class="logintitle marT15" >{{'Set your password' | translate}}</label>


          <form [formGroup]="resetPassForm" id="resetPassForm" role="form" (ngSubmit)="onresetPassFormSubmit()">
            <div class="flexStart marT10">
                <label class="labelTxt font12">{{'Account' | translate}}</label>
                <label class="domain-username marL20 padT5">{{data.domain}}\{{data.userName}}</label>
                 <!-- <label>{{data.domain}}/{{data.userName}}</label> -->
               
            </div>
            <div class="flexStart marT15">
              <div>
                <label class="labelTxt font12">{{'New password' | translate}}</label>
              </div>
              <div>                          
                <input class="eds-txt-blck marL20 inputTxtbox" [ngClass]="passwordAlert?'err-border':''" type="password" id="password" value=""
                    formControlName='password' (ngModelChange)="validatePassword($event)"  placeholder="{{'Enter new password' | translate}}"/>
              </div>                
            </div>
            <div class="passCheck marT10">
              <div class="flexStart" >
                <span id="check2" *ngIf="passLength" class="marT3" ><img src="assets/images/rest_tick_green.png" width="15" height="15"></span>
                <span *ngIf="!passLength" class="marT3"><img src="assets/images/rest_tick_grey.png" width="15" height="15"></span>                   
                <label class="font12 marL5">{{'At least 6 characters' | translate}}</label>
              </div>
              <div class="flexStart" >
                <span id="check2" *ngIf="passNumber" class="marT3" ><img src="assets/images/rest_tick_green.png" width="15" height="15"></span>
                <span  *ngIf="!passNumber" class="marT3"><img src="assets/images/rest_tick_grey.png" width="15" height="15"></span>
               
                <label class="font12 marL5">{{'At least 1 number' | translate}}</label>
              </div>
              <div class="flexStart" >
               <!--  <i class="icon icon-alarm-level6"><i class="icon icon-check eric-white" style="margin-left:-15px ;"></i>
              </i> -->

                <span id="check3" *ngIf="passSymbol" class="marT3" ><img src="assets/images/rest_tick_green.png" width="15" height="15"></span>
                <span  *ngIf="!passSymbol" class="marT3"><img src="assets/images/rest_tick_grey.png" width="15" height="15"></span>
                
                <label class="font12 marL5">   {{'At least 1 symbol' |translate }}   !@#$%&*()</label>
              </div>
            </div>
            <div class="flexStart marT10">
              <div>
                <label class="labelTxt font12">{{'Re-enter' | translate}}</label>
              </div>
            
              <div>                          
                  <input class="eds-txt-blck marL20 inputTxtbox" [ngClass]="passwordAlert?'err-border':''" type="password" id="password1" type="password" formControlName='password1'  placeholder="{{'Re-enter new password' | translate}}"/>
              </div>
              
          </div>
            <div  class="marT5 err-hgt">
              <label *ngIf="passwordAlert!=''" class="passCheck error-message"><span *ngIf="passwordAlert">{{'Error' | translate}}: </span>{{passwordAlert}}</label>
            </div>
           <!--  <div *ngIf="passwordErrMessage!=''"  style="margin-top: 10px;">
              <P style="width:200px;float:right;margin-top: 5px;margin-bottom: 20px;display: inline-block; color: #999999;font-size:11px;">{{passwordErrMessage}}</P>
            </div> -->

           
              <div class="pull-right marT15 hgt-30" >
                <button type="submit" class="btn primary" [disabled]="!passValidated">{{'Continue' | translate}}</button>
              </div>
          </form>
        </div>
      </div>
      <div class="bottom">                
        <div class="eric-white">{{'copyright' | translate}}</div>
      </div>
    </div>

    <div class="modal fade in smallmodal noDisplay" id="errorModal" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false" aria-labelledby="basicModal" aria-hidden="false" >
      <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
              <div class="modal-header">
                  <div class="modal-title" id="myModalLabel">
                      <span><img src="assets/images/redwarning.png" width="26" height="26"></span>&nbsp; {{this.titleMessage}}
                  </div>
              </div>
              <div class="modal-body">
                  <div class="modal-text">
                    <p>
                      <strong>{{this.subTitleMessage}}</strong>
                    </p>
                    <p class="grey-text" *ngIf="this.detailMessage">{{this.detailMessage}}</p>
                  </div>
              </div>
              <div class="modal-footer">
                  <p align="center">
                      <a href="#" class="btn btn-next" data-dismiss="modal" (click)="redirect()">&nbsp;&nbsp;OK&nbsp;&nbsp;</a>
                  </p>
              </div>
          </div>
      </div>    
    </div>
  </div>
</main>